import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal,  DatePicker,  theme,  Row,  Spin,  Space, Select, InputNumber ,} from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL, URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import _ from 'lodash';
import { ORANGE_COLOR, PRIMARY_COLOR } from "../../constants/color";

export default function ManageStockSkimChemicalModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate, direction } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      setErrorMessages(null);
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorError },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data['transaction'] = target.id
      await POST(`${URL_CHEMICAL.SKIM_CHEMICAL_WITHDRAW}`, data);
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={direction === 'add' ? "เพิ่มสต๊อก" : "ตัดสต๊อก"}
      cancelText="ยกเลิก"
      title={direction === 'add' ? `เพิ่มสต๊อก[${target ? target.lot_no : "-"}]` : `ตัดสต๊อก[${target ? target.lot_no : "-"}]`}
      width={420}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: ORANGE_COLOR},
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
          <Form.Item
            label="จำนวน"
            name="amount"
            rules={[{  required: true, message : 'กรุณากรอกข้อมูล'}]}
          >
              <InputNumber style={{ width: '100%' }} placeholder={"จำนวน"}/>
          </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
